import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-dropdown-selector',
  templateUrl: './custom-dropdown-selector.component.html',
  styleUrls: ['./custom-dropdown-selector.component.scss']
})
export class CustomDropdownSelectorComponent implements OnInit {

  @Input() label: string = this.translateService.instant('reports.degeocode-radius');
  @Input() selectOptions = [];
  @Input() selectedValue: number;

  @Output() selectedValueChange = new EventEmitter<any>();

  selectedObjectFromList: any;
  dataIsLoading = true;

  constructor(private translateService: TranslateService) {
    this.selectedObjectFromList = this.selectOptions[0];
  }

  ngOnInit() {
    this.dataIsLoading = false;
  }

   onSelectedValueChange() {
     this.selectedValue = this.selectedObjectFromList.value;
    this.selectedValueChange.emit(this.selectedValue);
  }

}
